import { toast } from 'sonner';
import { notify } from '../notify';

export const useNotification = () => {
    const clearNotifications = () => {
        toast.dismiss();
    };

    return {
        addNotification: notify,
        clearNotifications,
    };
};
